export default function atMentionsPluginTrigger(evt, editor) {
    if (evt.eventType === 1 /* KeyPress */) {
        var keyboardEvent = evt.rawEvent;
        return keyboardEvent.key == '@' || (keyboardEvent.key == '2' && keyboardEvent.shiftKey);
    }
    return false;
}
//# sourceMappingURL=atMentionsPluginTrigger.js.map